import { render, staticRenderFns } from "./StoreBase.vue?vue&type=template&id=412e3106&"
import script from "./StoreBase.vue?vue&type=script&lang=ts&"
export * from "./StoreBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports